import {atom, selector, useRecoilState} from "recoil";
import {useEffect} from "react";
import {requestCheckUserSession, requestLogin, requestLogout} from "../api/signcard";

// {
//     isLogin: false,
//     nickname: ""
// }

const initUserSession = {isLoading: false, isLogin: false, profileName: null, profileLink: null}

export const LoginSessionState = atom({
    key: 'LoginSessionState',
    default: {...initUserSession, isLoading: true}
});

export const IsLoginState = selector({
    key: 'isLoginState',
    get: ({get}) => [get(LoginSessionState).isLoading, get(LoginSessionState).isLogin]
});

export const ProfileInfoState = selector({
    key: 'profileInfoState',
    get: ({get}) => ({
        profileName: get(LoginSessionState).profileName,
        profileLink: get(LoginSessionState).profileLink
    })
});

export const useCheckSession = () => {
    const [loginSessionState, setLoginSessionState] = useRecoilState(LoginSessionState)

    useEffect(() => {
        //TODO have to check expiration
        setLoginSessionState({...loginSessionState, isLoading: true})
    }, [])

    const checkUserSession = async () => {
        try {
            const res = await requestCheckUserSession()
            if (res.status === 200) {
                const profileName = res.data.result.profileName
                const profileLink = res.data.result.profileLink
                setLoginSessionState({
                    isLoading: false,
                    isLogin: true,
                    profileName: profileName,
                    profileLink: profileLink
                })
            } else {
                setLoginSessionState(initUserSession)
            }
        } catch (err) {
            setLoginSessionState(initUserSession)

            if (err.response.status === 401) {
                window.location = "/login"
            }
        }
    }

    useEffect(() => {
        if (!loginSessionState.isLoading) {
            return
        }

        checkUserSession()
    }, [loginSessionState.isLoading, setLoginSessionState])
}

export const useSetUserSession = () => {
    const [loginSessionState, setLoginSessionState] = useRecoilState(LoginSessionState)

    const login = async (oauthProvider, oauthAccessToken) => {
        try {
            const res = await requestLogin(oauthProvider, oauthAccessToken)
            const profileName = res.data.result.profileName
            const profileLink = res.data.result.profileLink
            setLoginSessionState({
                isLoading: false,
                isLogin: true,
                profileName: profileName,
                profileLink: profileLink
            })

            return [true, profileLink]
        } catch (e) {
            setLoginSessionState(initUserSession)

            return [false, null]
        }
    }

    const logout = async () => {
        await requestLogout()
        setLoginSessionState(initUserSession)
    }

    const updateProfileInfo = (profileName, profileLink) => {
        setLoginSessionState({...loginSessionState, profileName: profileName, profileLink: profileLink})
    }

    return [login, logout, updateProfileInfo]
}